import { Accordion } from "radix-ui";

export const AccordionTrigger = ({ children, ...props }) => {
  return (
    <Accordion.Trigger
      className="group flex w-full items-center justify-between py-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      {...props}
    >
      {children}
    </Accordion.Trigger>
  );
};
